import React, { useEffect, useState } from "react";
import { showToast } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import PromopageAction from "./page-action/PromoPageAction";
import {
  alertActions,
  buttonName,
  createAccPage,
  createPromocode,
  fieldValidation,
  reset_password
} from "../../locales/en";
import {
  LOWEST_VALUE,
  showToastType
} from "../../utils/constants/appConstants";

import { getClientStatusThunk } from "../../redux/pricingplanSlice";
import { useDispatch } from "react-redux";
import { createPromocodethunk } from "../../redux/promocodeSlice";
import { sanitizeInput } from "../../utils/utils";
import {
  getActiveStatus,
  getInvoiceOptions,
  getSingleUseOptions
} from "../../utils/getDropdownOptions";
import { ADMIN_PROMO_CODES, CREATE_PROMO_CODE } from "../../route/paths";

export default function CreatePromoCode() {
  const dispatch = useDispatch();
  const [userStatus, setUserStatus] = useState([]);
  const initialPromoCode = {
    code: "",
    discountPercent: "",
    discountAmount: "",
    title: "",
    description: "",
    purpose: "",
    invoiceSelection: LOWEST_VALUE,
    status: [],
    isSingleUse: true,
    isActive: true
  };
  const [promoCode, setPromoCode] = useState(initialPromoCode);

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const history = useNavigate();

  const {
    code,
    discountPercent,
    discountAmount,
    title,
    description,
    purpose,
    invoiceSelection,
    status
  } = promoCode;

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setPromoCode((prevState) => {
        const updatedCustomers = checked
          ? [...prevState.status, name]
          : prevState.status.filter((item) => item !== name);
        return {
          ...prevState,
          status: updatedCustomers
        };
      });
    } else if (name === "isActive") {
      setPromoCode((prevState) => ({
        ...prevState,
        [name]: value === "Active"
      }));
    } else if (name === "isSingleUse") {
      setPromoCode((prevState) => ({
        ...prevState,
        [name]: value === "Yes"
      }));
    } else if (name === "discountPercent" && value > 100) {
      setPromoCode((prevState) => ({
        ...prevState,
        [name]: Math.min(parseInt(sanitizeInput(value), 10), 100)
      }));
    } else if (name === "discountAmount") {
      setPromoCode((prevState) => ({
        ...prevState,
        [name]: parseInt(sanitizeInput(value), 10)
      }));
    } else {
      setPromoCode((prevState) => ({
        ...prevState,
        [name]: sanitizeInput(value)
      }));
    }

    // Remove errors for the current field and discount error
    const newErrors = { ...errors, [name]: "" };
    if (name === "discountPercent" || name === "discountAmount") {
      newErrors.discount = "";
    }
    setErrors(newErrors);
  };

  const validate = () => {
    const tempErrors = {};
    if (!code.trim()) {
      tempErrors.code = fieldValidation.required;
    } else if (code.length < 6) {
      tempErrors.code = createPromocode?.errMsg.item1;
    }

    if (!title.trim()) {
      tempErrors.title = fieldValidation.required;
    }

    if (!description) {
      tempErrors.description = fieldValidation.required;
    }

    if (!purpose) {
      tempErrors.purpose = fieldValidation.required;
    }

    if (!status.length) {
      tempErrors.status = createPromocode?.errMsg.item2;
    }

    if (!discountPercent && !discountAmount) {
      tempErrors.discount = createPromocode?.errMsg.item3;
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!validate()) {
      return;
    }

    try {
      let discountType = "";
      if (promoCode.discountPercent) {
        discountType = "percentage";
      } else if (promoCode.discountAmount) {
        discountType = "dollar";
      }

      const dataToSend = {
        code: sanitizeInput(promoCode.code),
        discount: {
          type: discountType,
          value:
            sanitizeInput(promoCode.discountAmount?.toString()) ||
            sanitizeInput(promoCode.discountPercent?.toString())
        },
        title: sanitizeInput(promoCode.title),
        description: sanitizeInput(promoCode.description),
        purpose: sanitizeInput(promoCode.purpose),
        invoiceSelection: sanitizeInput(promoCode.invoiceSelection),
        userStatusMappings: {
          status: promoCode.status.map(sanitizeInput).join(",")
        },
        isSingleUse: promoCode.isSingleUse,
        isActive: promoCode.isActive,
        integrationUrl: "https://example.com/integration"
      };

      const response = await dispatch(
        createPromocodethunk(dataToSend)
      ).unwrap();

      // Handle success
      showToast(response.data.message, showToastType.success);
      history(ADMIN_PROMO_CODES);
    } catch {
      // handle catch here;
    }
  };
  const handleCancel = () => {
    setPromoCode({
      code: "",
      discountPercent: "",
      discountAmount: "",
      title: "",
      description: "",
      purpose: "",
      invoiceSelection: "LOWEST_VALUE",
      status: [],
      isSingleUse: true,
      isActive: true
    });
    setErrors({});
    history(ADMIN_PROMO_CODES);
  };
  useEffect(() => {
    // Load Quote Status
    const loaduserStatus = async () => {
      try {
        const response = await dispatch(getClientStatusThunk()).unwrap();
        const responseData = response.data.data || [];
        const formattedUserStatus = responseData.map((status) => ({
          value: status.id,
          label: status.status
        }));
        setUserStatus(formattedUserStatus);
      } catch {
        // handle catch here;
      }
    };
    loaduserStatus();
  }, []);

  return (
    <>
      <TablePagesTitle
        mainTitle="Promo Code"
        content={createPromocode?.mainTitle}
      />

      <PromopageAction
        subheading={createPromocode?.mainTitle}
        allpromocodes={ADMIN_PROMO_CODES}
        createpromocodes={CREATE_PROMO_CODE}
      />

      <div className="row mb-3 mx-0">
        <div className="col-md-12 sale-leade-form mt-3">
          {message && (
            <div className="alert alert-success mt-2 mb-2">{message}</div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="promoCode">
                    {createPromocode?.promoCode}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Promo Code"
                    name="code"
                    onChange={onInputChange}
                    value={code}
                  />
                  {errors.code && (
                    <div className="text-danger small">{errors.code}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="discount">{createPromocode?.discount}</label>
                </div>
              </div>
              <div className="row col-sm-8 mx-0 px-0">
                <div className="col-sm-5 sign_box">
                  <div className="input-group">
                    <input
                      type="number"
                      placeholder="Discount(%)"
                      name="discountPercent"
                      min="0"
                      onChange={onInputChange}
                      value={discountPercent}
                      disabled={!!discountAmount}
                    />
                    <p>%</p>
                  </div>
                  {errors.discount && (
                    <div className="text-danger small">{errors.discount}</div>
                  )}
                </div>
                <div className="col-sm-2  d-flex  align-items-center">
                  <div className="input-group my-2 my-sm-0 justify-content-center">
                    {reset_password.or}
                  </div>
                </div>
                <div className="col-sm-5 sign_box">
                  <div className="input-group">
                    <p>$</p>
                    <input
                      type="number"
                      placeholder="Discount Amount"
                      name="discountAmount"
                      min="0"
                      onChange={onInputChange}
                      value={discountAmount}
                      disabled={!!discountPercent}
                    />
                  </div>
                  {errors.discount && (
                    <div className="text-danger small">{errors.discount}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="title">{createPromocode?.title}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Title"
                    name="title"
                    onChange={onInputChange}
                    value={title}
                  />
                  {errors.title && (
                    <div className="text-danger small">{errors.title}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="summary">{createPromocode?.summary}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <textarea
                    placeholder="description"
                    name="description"
                    onChange={onInputChange}
                    value={description}
                  />
                  {errors.description && (
                    <div className="text-danger small">
                      {errors.description}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="purpose">{createPromocode?.purpose}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <textarea
                    placeholder="Purpose"
                    name="purpose"
                    onChange={onInputChange}
                    value={purpose}
                  />
                  {errors.purpose && (
                    <div className="text-danger small">{errors.purpose}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="applyDiscountTo">
                    {createPromocode?.applyDiscountTo}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <select
                    id="invoiceSelection"
                    name="invoiceSelection"
                    onChange={onInputChange}
                    value={invoiceSelection}
                  >
                    {getInvoiceOptions().map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="applyToCstmr">
                    {createPromocode?.applyToCstmr}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <ul>
                    {userStatus.map((data) => (
                      <li key={data.value}>
                        <input
                          type="checkbox"
                          name={String(data.value)}
                          id={String(data.value)}
                          onChange={onInputChange}
                          checked={status.includes(String(data.value))}
                        />
                        <label htmlFor={data.value}>{data.label}</label>
                      </li>
                    ))}
                  </ul>
                  {errors.status && (
                    <div className="text-danger small">{errors.status}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="applyOncePerCstmr">
                    {createPromocode?.applyOncePerCstmr}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <select
                    id="isSingleUse"
                    name="isSingleUse"
                    onChange={onInputChange}
                    value={promoCode.isSingleUse ? "Yes" : "No"}
                  >
                    {getSingleUseOptions().map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="status">{createAccPage?.status}</label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <select
                    id="isActive"
                    name="isActive"
                    onChange={onInputChange}
                    value={promoCode.isActive ? "Active" : "Inactive"}
                  >
                    {getActiveStatus().map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-8 offset-sm-4 d-flex d-sm-block justify-content-center justify-content-sm-start">
                <button
                  type="button"
                  className="btn btn-red me-2"
                  onClick={handleCancel}
                >
                  {alertActions?.Cancel}
                </button>
                <button type="submit" className="btn btn-primary">
                  {buttonName?.create}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
